var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_223_107",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0002 23.8L48.0002 34L48.0002 -2.28882e-05L30.0002 10.2V-2.28882e-05L0.000244141 17L30.0002 34V23.8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0002 34L46.5212 36.6101L51.0002 39.1482L51.0002 34L48.0002 34ZM30.0002 23.8L31.4793 21.1899L27.0002 18.6518L27.0002 23.8H30.0002ZM48.0002 -2.28882e-05H51.0002L51.0002 -5.14821L46.5212 -2.61009L48.0002 -2.28882e-05ZM30.0002 10.2H27.0002V15.3482L31.4793 12.81L30.0002 10.2ZM30.0002 -2.28882e-05H33.0002L33.0002 -5.14821L28.5212 -2.61009L30.0002 -2.28882e-05ZM0.000244141 17L-1.47879 14.3899L-6.08479 17L-1.47879 19.6101L0.000244141 17ZM30.0002 34L28.5212 36.6101L33.0002 39.1482V34H30.0002ZM49.4793 31.3899L31.4793 21.1899L28.5212 26.4101L46.5212 36.6101L49.4793 31.3899ZM45.0002 -2.28882e-05L45.0002 34L51.0002 34L51.0002 -2.28882e-05H45.0002ZM31.4793 12.81L49.4793 2.61004L46.5212 -2.61009L28.5212 7.58992L31.4793 12.81ZM27.0002 -2.28882e-05V10.2H33.0002V-2.28882e-05H27.0002ZM1.47928 19.6101L31.4793 2.61004L28.5212 -2.61009L-1.47879 14.3899L1.47928 19.6101ZM31.4793 31.3899L1.47928 14.3899L-1.47879 19.6101L28.5212 36.6101L31.4793 31.3899ZM27.0002 23.8V34H33.0002V23.8H27.0002Z",
    fill: "#DFF8FF",
    mask: "url(#path-1-inside-1_223_107)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindIcon);
export default __webpack_public_path__ + "static/media/rewind-icon.91deabe9c0195fa416272b86c7fe8469.svg";
export { ForwardRef as ReactComponent };